import { useMutation, useQueryClient } from "@tanstack/react-query";

import { segmentsQueryKeys } from "./queryKeys";

import { savedSegmentSchema, type SegmentCopyOptions } from "@/features/segments/builder/schemas";
import { instance } from "@/lib/axios/instance";

type DuplicateSegmentVariables = {
  segmentId: string;
  clientId?: string;
  name: string;
  copy: SegmentCopyOptions;
};

export function useDuplicateSegment() {
  const queryClient = useQueryClient();

  return useMutation<string, Error, DuplicateSegmentVariables>({
    mutationFn: async ({ segmentId, clientId, name, copy }) => {
      const response = await instance.post(
        `/api/v2/Segments/${segmentId}/duplicate`,
        {
          name,
          copyRules: copy.rules,
          copyIncludedVacancies: copy.includedVacancies,
          copyExcludedVacancies: copy.excludedVacancies,
        },
        { params: clientId ? { clientId } : {} },
      );
      return savedSegmentSchema.parse(response.data).id;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: segmentsQueryKeys.all,
      });
    },
  });
}
